import React from 'react';
import { GrPowerReset } from 'react-icons/gr';
import styled from 'styled-components';
import { colors, theme } from 'theme';
import { useSelector } from 'react-redux';

const Button = styled.div`
	cursor: pointer;
	display: flex;
	flex-direction: ${({ isMobile }) => (isMobile ? 'row' : 'column')};
	align-items: center;
	height: 24px;
	margin-right: ${({ isMobile }) => (isMobile ? '0px' : theme.margin.smmd)};
	margin-left: auto;
	font-size: ${theme.fontSizes.sm};
	color: ${colors.outlines.error};
`;

const Icon = styled.div`
	color: ${colors.outlines.error};
	font-size: ${theme.fontSizes.md};
	width: ${({ isMobile }) => (isMobile ? '16px' : '20px')};
	height: ${({ isMobile }) => (isMobile ? '16px' : '20px')};
	margin-right: ${({ isMobile }) => (isMobile ? '4px' : '0px')};
	display: flex;
	justify-content: center;
	padding-bottom: ${({ isMobile }) => (isMobile ? '0px' : theme.padding.xxs)};
`;

export function ResetButton({ onClick }) {
	const isMobile = useSelector((state) => state.ui.isMobile);
	return (
		<Button isMobile={isMobile} onClick={onClick}>
			<Icon isMobile={isMobile}>
				<GrPowerReset />
			</Icon>
			Reset
		</Button>
	);
}
